<template>

  <v-container fluid class="px-10 pt-8 pb-8 order-attachment-documents">

    <!-- Attachment Docs submitted with RouteLeaf Order -->
    <div class="title">
      Attachment Documents <span v-if="docCount > 0">({{ docCount }})</span>
    </div>

    <!-- Re-upload action -->
    <v-row class="mb-4 mt-6" v-if="canReupload">
      <v-col align="center">
        <reupload-order-documents
            docType="attachment"
            buttonText="Change Attachment Docs"
            :order="order"
            @uploading="isDataUpdating = true"
            @success="completeDocChanges"
            @failure="completeDocChanges" />
      </v-col>
    </v-row>

    <template v-if="!isDataUpdating">
      <!-- Download links -->
      <v-row class="mt-8" v-if="hasAttachmentDocs">
        <v-col cols="12">
          <div class="mb-6" v-for="(docInfo, key) in attachmentDocs" :key="key">
            <v-icon class="mr-1 icon-download" color="primary">mdi-download</v-icon>
            <a :href="generateAttachmentLink(key, docInfo)" class="download-link" target="_new">
              {{ docInfo.label }}
            </a>
          </div>
        </v-col>
      </v-row>

      <!-- (no docs) -->
      <v-row class="mt-6" v-else>
        <v-col align="center">
          <span>(No attachment docs)</span>
        </v-col>
      </v-row>
    </template>

  </v-container>

</template>

<script>
import ReuploadOrderDocuments from '@/components/orders/ReuploadOrderDocuments'

const DATA_API_BASE_URL = process.env.VUE_APP_DATA_API_BASE_URL

export default {
  name: 'OrderAttachmentDocuments',

  components: {
    ReuploadOrderDocuments
  },

  data () {
    return {
      orderIdForAssets: null,
      isDataUpdating: false,
      isAttachmentDocsDialogOpen: false,
      newAttachmentDocs: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    attachmentDocs () {
      return (this.order) ? this.order.attachment_docs : null
    },
    hasAttachmentDocs () {
      return (this.attachmentDocs && !this.$root.utils.isEmpty(this.attachmentDocs))
    },
    docCount () {
      return (this.hasAttachmentDocs) ? Object.keys(this.attachmentDocs).length : 0
    },
    canReupload () {
      return (
        this.uiType === 'shipper' &&
        this.order.order_status !== 'RESCHEDULED' &&
        this.order.order_status !== 'REJECTED_ON_DELIVERY' &&
        (this.$root.activeUserHasRole('admin') || this.$root.activeUserHasRole('dispatcher'))
      )
    }
  },

  async beforeMount () {
    // Load order ID for assets
    this.orderIdForAssets = (this.order.root_order_id) ? this.order.root_order_id : this.order.id
  },

  methods: {
    generateAttachmentLink (assetKey, docInfo) {
      return `${DATA_API_BASE_URL}/order/${this.orderIdForAssets}/asset/download?asset_key=${assetKey}&file_type=${docInfo.file_type}&file_name=${docInfo.file_name}`
    },

    completeDocChanges (results) {
      this.isDataUpdating = false
      this.$parent.reloadOrderData() // reload order
    }
  }
}
</script>

<style scoped>
  .order-attachment-documents a.download-link {
    text-decoration: none;
  }

  .order-attachment-documents a.download-link:hover {
    text-decoration: underline;
  }
</style>
